import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useValidate, usePrincipleSubmit, useInitialValues, PrincipleFormValues, usePrincipleHistoryQuery, usePricipleHistoryReset, PrincipleHistoryType } from 'components/Principle/Principle.hooks';
import { useStocksBySymbol, useStocksQuery } from 'components/Stock/Stock.hooks';
import { CurrentPriceHiddenField } from 'components/Principle/CurrentPriceHiddenField';
import { PrincipleHistoryItem } from 'components/Principle/PrincipleHistoryItem';
import { usePageTitle } from 'routes/Util/Util.hooks';

export const Principle = () => {
  usePageTitle('리스크 관리');
  const initialValues = useInitialValues();
  const validate = useValidate();
  const onSubmit = usePrincipleSubmit();
  const onResetClick = usePricipleHistoryReset();
  const { data: stocks } = useStocksQuery('us');
  const stockBySymbol = useStocksBySymbol('us', { includeIndex: false });
  const { data: histories } = usePrincipleHistoryQuery();
  return (
    <Container>
      <Row>
        <Col>
          <h3>위험 보상 비율 설정{' '}<a className="text-decoration-none fs-6" href="https://youtu.be/xEpulI5xywA" target="_blank" rel="noopener noreferrer">(참고 영상)</a></h3>
        </Col>
      </Row>
      <br />
      <Formik<PrincipleFormValues>
        initialValues={initialValues}
        validate={validate}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <CurrentPriceHiddenField name="currentPrice" />
            <Row>
              <Col xs={12}>
                <div className="row mb-3">
                  <label htmlFor="budget" className="col-sm-4 col-md-2 col-form-label">예산</label>
                  <div className="col-sm-8 col-md-10">
                    <div className="input-group flex-nowrap">
                      <span className="input-group-text">$</span>
                      <Field type="text" className="form-control" id="budget" name="budget" placeholder="10,000" />
                    </div>
                    <ErrorMessage name="budget" />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div className="row mb-3">
                  <label htmlFor="riskRewardRatio" className="col-sm-4 col-form-label">위험 보상 비율</label>
                  <div className="col-sm-8">
                    <Field type="text" className="form-control" id="riskRewardRatio" name="riskRewardRatio" placeholder="1:2" />
                    <ErrorMessage name="riskRewardRatio" />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div className="row mb-3">
                  <label htmlFor="maximumRiskLimit" className="col-sm-4 col-form-label">최대 위험 한도</label>
                  <div className="col-sm-8">
                    <div className="input-group flex-nowrap">
                      <Field type="text" className="form-control" id="maximumRiskLimit" name="maximumRiskLimit" placeholder="2%" />
                      <span className="input-group-text">%</span>
                    </div>
                    <ErrorMessage name="maximumRiskLimit" />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div className="row mb-3">
                  <label htmlFor="symbol" className="col-sm-4 col-form-label">종목</label>
                  <div className="col-sm-8">
                    <Field
                      component="select"
                      id="symbol"
                      name="symbol"
                      className="form-select"
                    >
                      {stocks.map(stock => <option key={stock.symbol} value={stock.symbol}>{stock.krShortName}</option>)}
                    </Field>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div className="row mb-3">
                  <label htmlFor="atr" className="col-sm-4 col-form-label">ATR (Average True Range)</label>
                  <div className="col-sm-8">
                    <Field type="text" className="form-control" id="atr" name="atr" placeholder="14.2" />
                    <ErrorMessage name="atr" />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="text-end">
                <Button type="submit" disabled={isSubmitting}>
                  계산
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
      <hr className="my-5" />
      <Row>
        <Col className="d-flex justify-content-between align-items-center">
          <h4 className="mb-0">과거 기록<br /><small className="text-muted fs-6">(최대 20개까지 브라우저에 저장됩니다.)</small></h4>
          <Button className="btn-secondary" type="button" onClick={onResetClick}>초기화</Button>
        </Col>
      </Row>
      {histories && Object.keys(stockBySymbol).length > 0 && (
        <Row className="row-cols-1 row-cols-xs-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
          {histories.map((history: PrincipleHistoryType) =>
            <Col key={history.date}>
              <PrincipleHistoryItem stock={stockBySymbol[history.symbol]} {...history} />
            </Col>
          )}
        </Row>
      )}
      {histories?.length === 0 && <Row><Col><p className="text-center p-5 text-muted">과거 기록이 없습니다.</p></Col></Row>}
    </Container>
  )
}
